export default __webpack_public_path__ + "static/font-b89006e6f23ad5003f59ad40e1bfbe0f.woff";